import { Injectable } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  constructor(private deviceService: DeviceDetectorService) {}

  /**Funcion para chequear si el dispositivo es movil */
  isMobile() {
    return this.deviceService.isMobile();
  }

}
